/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import HeadingElement from '../HeadingElement';
import ContentElement from '../ContentElement';
import TextInputElement from '../TextInputElement';
import BooleanElement from '../BooleanElement';
import MultichoiceElement from '../MultichoiceElement';
import FileUploadElement from '../FileUploadElement';
import LocationInputElement from '../LocationInputElement';
import { IconWithText } from '../../../uiold';

export const form = {
  HeadingElement,
  ContentElement,
  TextElement: TextInputElement,
  BooleanElement,
  MarketSelectorElement: null,
  MultichoiceElement,
  FileUploadElement,
  LocationInput: LocationInputElement,
};

export const formElementTypes = Object.keys(form);

export default function renderElementMenuItem(
  type: keyof typeof form,
): React.ReactNode {
  let Element = form[type];
  return (
    !!Element && (
      <IconWithText
        iconName={Element.getIconName() as any}
        text={Element.getDescription()}
      />
    )
  );
}
